var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_vm._t("default")],2)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }